import React, { PropsWithChildren, useState } from 'react';
import Div from '../Div';
import Button from '../Button';
import classNames from 'classnames';
import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import ChevronUpIcon from '@/components/Icons/ChevronUpIcon';

type ExpandableContentProps = {
  contentHeight: number;
  className?: string;
  showMoreCTA?: string;
  showLessCTA?: string;
};
const FIXED_CONTENT_HEIGHT = 150;

const calculateHeightStyle = (isExpanded: boolean, contentHeight: number) => {
  if (isExpanded) {
    return 'auto';
  }
  return contentHeight <= FIXED_CONTENT_HEIGHT ? `${contentHeight}px` : `${FIXED_CONTENT_HEIGHT}px`;
};

const ExpandableContent = ({
  children,
  contentHeight,
  className,
  showMoreCTA = 'Show More',
  showLessCTA = 'Show Less',
}: PropsWithChildren<ExpandableContentProps>) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const heightOfContent = calculateHeightStyle(isExpanded, contentHeight);
  return (
    <Div className="relative expandible-content">
      <Div
        className={classNames('', className, {
          'overflow-y-hidden': !isExpanded,
        })}
        style={{ height: heightOfContent }}
      >
        {children}
      </Div>
      {contentHeight > FIXED_CONTENT_HEIGHT ? (
        <Button size="sm" className="!pl-0 !gap-s2" onClick={handleToggle} theme="link">
          {isExpanded ? showLessCTA : showMoreCTA}
          {isExpanded ? <ChevronUpIcon fill="#1A73E9" /> : <ChevronDownIcon fill="#1A73E9" />}
        </Button>
      ) : null}
    </Div>
  );
};

export default ExpandableContent;
